var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('EditorContent',{staticClass:"mb-3",attrs:{"editor":_vm.editor}}),_c('span',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.creator)+", "+_vm._s(_vm._f("moment")(_vm.timestamp,"ddd DD MMM [']YY HH:mm")))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }